import { useRef, useEffect } from "react";
import { Flex, Text, TextArea } from "@radix-ui/themes";
import { useMutation } from "@tanstack/react-query";
import { recordResponse } from "@api/survey";
import PropTypes from "prop-types";
import { useLingui } from "@lingui/react";
import { useSurveyStore } from "@src/store/survey";

LongTextQuestion.propTypes = {
  question: PropTypes.object,
};

export default function LongTextQuestion({ question }) {
  const { sessionUUID, surveyResponses, setSurveyResponses } = useSurveyStore(
    (state) => ({
      sessionUUID: state.sessionUUID,
      surveyResponses: state.surveyResponses,
      setSurveyResponses: state.setSurveyResponses,
    }),
  );
  const uuid = useRef(null);
  const { i18n } = useLingui();
  const response = useMutation({
    mutationFn: recordResponse,
    onSuccess: (data) => {
      setSurveyResponses((state) => {
        return { ...state.surveyResponses, [question.uuid]: data.response };
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });

  useEffect(() => {
    uuid.current = self.crypto.randomUUID();
  }, []);

  async function valueChange(blur) {
    const value = blur.target.value;
    if (value === "") {
      return;
    }

    let responseData = {
      answer: value,
    };

    response.mutate({
      answerUUID: uuid.current,
      response: responseData,
      sessionUUID: sessionUUID,
      surveyQuestionUUID: question.uuid,
    });
  }

  if (question !== undefined) {
    return (
      <Flex direction="column">
        <Text as="p" size="3" mb="2" weight="bold">
          {question.question}
        </Text>
        <Text as="p" size="1" color="gray" mb="2">
          {question.hint_text}
        </Text>
        <TextArea
          onBlur={valueChange}
          defaultValue={surveyResponses?.[question.uuid]?.answer}
          placeholder={
            question.hint_text ||
            i18n._({
              id: "questions.LongTextQuestion.enter_answer",
              message: "Enter your answer",
            })
          }
        />
      </Flex>
    );
  } else {
    return null;
  }
}
